import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Favorite from "@material-ui/icons/Favorite";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";

import KisetsuNavbar from "components/Header/KisetsuNavbar";
import blogPostPageStyle from "assets/jss/material-kit-pro-react/views/blogPostPageStyle.js";

const useStyles = makeStyles(blogPostPageStyle);

export default function BlogPostPage() {
  const classes = useStyles();
  const { slug } = useParams();

  const [post, setPost] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    fetch(`https://ecommerce24.pythonanywhere.com/api/blog/${slug}/`)
      .then((res) => res.json())
      .then((data) => setPost(data))
      .catch((err) => console.error(err));
  }, [slug]);

  if (!post) return <div className={classes.container}>Yükleniyor...</div>;

  return (
    <div>
      <KisetsuNavbar />
      <Parallax image={post.cover_image} filter="dark" small>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem md={8} sm={10} className={classes.textCenter}>
              <h1
                className={classes.title}
                style={{ fontSize: "3rem", fontWeight: 700 }}
              >
                {post.title}
              </h1>
              <h4
                className={classes.subtitle}
                style={{
                  fontWeight: 400,
                  color: "#eee",
                  marginBottom: "1rem",
                  fontSize: "1.2rem",
                }}
              >
                {new Date(post.created_at).toLocaleDateString("tr-TR")}
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div
        className={classes.main}
        style={{
          paddingTop: "3rem",
          paddingBottom: "3rem",
          backgroundColor: "#fff",
        }}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem md={10}>
              <div
                className="post-content"
                style={{
                  fontSize: "1.1rem",
                  lineHeight: 1.8,
                  color: "#333",
                  fontFamily: "Georgia, serif",
                  padding: "0 1rem",
                }}
                dangerouslySetInnerHTML={{ __html: post.content }}
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>

      <Footer
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="/blog-posts" className={classes.block}>Blog</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/about-us" className={classes.block}>Hakkımızda</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/products" className={classes.block}>Mağaza</a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/contact-us" className={classes.block}>İletişim</a>
            </ListItem>
          </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()} , sevgiyle hazırlandı{" "}
              <Favorite className={classes.icon} />{" "}
              <a href="/" target="_blank" rel="noopener noreferrer">
                Kisetsu
              </a>{" "}
              ile planlı ve estetik bir yaşam için.
            </div>
          </div>
        }
      />
    </div>
  );
}
